import { Box } from "@mui/material";
import { ReactElement, useEffect } from "react";
import Retool from "react-retool";
import { useNavigate } from "react-router-dom";

import PageContainer from "~frontend/components/PageContainer";
import { useTenant } from "~frontend/providers/LoggedInUserProvider";
import { useFeatureFlag } from "~frontend/providers/LoggedInUserProvider/context";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

const HEIGHT = 1500;

export const ExternalRegistration = (): ReactElement => {
  const tenant = useTenant()!;
  const { subaccount, subaccountLink } = useSubaccount()!;
  const navigate = useNavigate();
  const useJotformFor10dlcRegistration = useFeatureFlag(
    "useJotformFor10dlcRegistration"
  );

  const environment = import.meta.env.STW_RETOOL_ENV_NAME;

  useEffect(() => {
    const handleSuccess = (ev: MessageEvent<{ retoolId?: string }>) => {
      if (ev.data.retoolId) {
        navigate(subaccountLink("/phone-numbers"))?.catch(console.error);
      }
    };

    window.addEventListener("message", handleSuccess);

    return () => window.removeEventListener("message", handleSuccess);
  }, [navigate, subaccountLink]);

  return (
    <PageContainer sx={{ height: "100%" }}>
      {useJotformFor10dlcRegistration ? (
        <Box>
          <iframe
            id="JotFormIFrame-221586485715162"
            title="Register for 10DLC phone numbers"
            src="https://scaletowin.jotform.com/221586485715162"
            style={{
              minWidth: "100%",
              maxWidth: "100%",
              minHeight: HEIGHT,
              overflow: "scroll",
              border: "none",
            }}
            seamless
          ></iframe>
          <script src="https://scaletowin.jotform.com/s/umd/latest/for-form-embed-handler.js"></script>
          <script>
            window.jotformEmbedHandler("iframe[id='JotFormIFrame-221586485715162']",
            "https://scaletowin.jotform.com/")
          </script>
        </Box>
      ) : (
        <Box
          sx={{
            height: HEIGHT,
            "& iframe": {
              height: HEIGHT,
            },
          }}
        >
          <Retool
            url={`https://scaletowincs.retool.com/p/10dlc-registration?tenantId=${tenant.id}&subaccountId=${subaccount.id}&_environment=${environment}`}
          />
        </Box>
      )}
    </PageContainer>
  );
};
